import { Translatable } from "@icc/shared/helpers";

export type BlockHangerType = 'wbz' | 'lpt';

export class RollerBlockHanger {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    /** Kod do wydruków */
    printCode?: string;
    /** Typ wieszaka (WBZ lub LPT) */
    hangerType: BlockHangerType;
    /** Ilość wieszaków */
    quantity: number;
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
}

export interface IccRollerBlockHanger {
    id: number;
    extId: string;
    indexNo: string;
    name: string;
    /** Kod do wydruków */
    printCode?: string;
    hangerType: BlockHangerType;
    /** Powiązane typy produktów */
    shutterTypesIds: number[];
    /** Powiązane profile skrzynek i rur nawojowych */
    profilesIds: number[];
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
}
